export { default, type TRequestBodyInfoProps } from './request-body-info';
